(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rcc-hero-slider"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('rcc-hero-slider')) {
    class RccHeroSlider extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-track]');
        this.slides = Array.from(this.querySelectorAll('[data-slide]'));
        this.dots = Array.from(this.querySelectorAll('[data-dot]'));
        this.pauseBtn = this.querySelector('[data-pause]');
        this.index = 0;
        this.speed = parseInt(this.dataset.speed, 10) || 5000;
        this.reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.autoplay = this.dataset.autoplay === 'true' && this.slides.length > 1 && !this.reduced;
        this.userPaused = false;
        if (!this.track || this.slides.length < 2) return;

        this.querySelector('[data-prev]')?.addEventListener('click', () => this.go(this.index - 1));
        this.querySelector('[data-next]')?.addEventListener('click', () => this.go(this.index + 1));
        this.dots.forEach((d) => d.addEventListener('click', () => this.go(parseInt(d.dataset.dot, 10))));

        this.pauseBtn?.addEventListener('click', () => {
          this.userPaused = !this.userPaused;
          this.pauseBtn.setAttribute('aria-pressed', String(this.userPaused));
          this.pauseBtn.setAttribute('aria-label', this.userPaused ? 'Reanudar carrusel' : 'Pausar carrusel');
          this.userPaused ? this.stop() : this.start();
        });

        this.onScroll = () => {
          clearTimeout(this.scrollTimer);
          this.scrollTimer = setTimeout(() => {
            const i = Math.round(this.track.scrollLeft / this.track.clientWidth);
            this.setActive(Math.max(0, Math.min(i, this.slides.length - 1)));
          }, 60);
        };
        this.track.addEventListener('scroll', this.onScroll, { passive: true });

        this.addEventListener('mouseenter', () => this.stop());
        this.addEventListener('mouseleave', () => this.start());
        this.addEventListener('focusin', () => this.stop());
        this.addEventListener('focusout', (e) => { if (!this.contains(e.relatedTarget)) this.start(); });
        this.addEventListener('keydown', (e) => {
          if (e.key === 'ArrowLeft') { e.preventDefault(); this.go(this.index - 1); }
          if (e.key === 'ArrowRight') { e.preventDefault(); this.go(this.index + 1); }
        });

        this.onVisibility = () => (document.hidden ? this.stop() : this.start());
        document.addEventListener('visibilitychange', this.onVisibility);

        if (window.Shopify && Shopify.designMode) {
          this.slides.forEach((s, i) => {
            s.addEventListener('shopify:block:select', () => { this.editorLock = true; this.stop(); this.go(i, true); });
            s.addEventListener('shopify:block:deselect', () => { this.editorLock = false; this.start(); });
          });
        }

        this.setActive(0);
        this.start();
      }

      disconnectedCallback() {
        this.stop();
        if (this.onVisibility) document.removeEventListener('visibilitychange', this.onVisibility);
      }

      go(i, instant) {
        const n = this.slides.length;
        const target = (i + n) % n;
        this.track.scrollTo({ left: target * this.track.clientWidth, behavior: instant || this.reduced ? 'auto' : 'smooth' });
        this.setActive(target);
        if (this.timer) { this.stop(); this.start(); }
      }

      setActive(i) {
        this.index = i;
        this.slides.forEach((s, k) => {
          const active = k === i;
          s.setAttribute('aria-hidden', String(!active));
          s.toggleAttribute('inert', !active);
        });
        this.dots.forEach((d, k) => d.setAttribute('aria-selected', String(k === i)));
      }

      start() {
        if (!this.autoplay || this.userPaused || this.editorLock || this.timer) return;
        this.timer = setInterval(() => this.go(this.index + 1), this.speed);
      }

      stop() {
        clearInterval(this.timer);
        this.timer = null;
      }
    }
    customElements.define('rcc-hero-slider', RccHeroSlider);
  }

  } catch(e) { console.error(e); }
})();
})();
